import React from "react";
import { useLocation } from "react-router-dom";
import ScrollToTop from "../../Utility/ScrollToTop/ScrollToTop";
import { DealCouponData } from "../../Utility/Utility";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";

const TermsAndCondition = () => {
  const location = useLocation();
  const { dealCouponData } = DealCouponData();
  const searchParams = new URLSearchParams(location.search);
  const couponId = searchParams.get("couponId");
  const translation = getTranslation();

  const TermsAndCondition = dealCouponData?.find(
    (coupon) => coupon.id === Number(couponId)
  );
  return (
    <>
      <ScrollToTop />

      <div
        id="top_offer_main_wrapper_container"
        className=" top_offer_main_wrapper_container"
      >

        <div className="row ">
          {<CustomBackHeader
            isSticky={true}
            isTransperent={false}
            title={translation?.termsAndConditions}
            customClass="offer_title mobile_heading sticky top-0 z-10 bg-white"
          />}
          <div className="data-container">
            <div className="font-bold text-xl">{TermsAndCondition?.title} </div>
            <div className=" [&_ul]:list-inside
             [&_ul]:space-y-2
             [&_li]:pl-4
             [&_li]:-indent-4"
              dangerouslySetInnerHTML={{ __html: TermsAndCondition?.terms }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
